import { JourneysSupportedLDAPGroups } from '@amzn/journeys-common';
import { Select, SelectOption } from '@amzn/meridian';
import { sortBy } from 'es-toolkit/compat';
import type { LdapGroupSelectFragment } from 'generated/graphql';
import { type FC, useCallback, useState } from 'react';

const LDAPGroupOptions: {
  value: string;
  text: string;
}[] = sortBy(
  JourneysSupportedLDAPGroups.map((ldapGroup) => ({
    text: ldapGroup,
    value: ldapGroup,
  })),
  (option) => option.text.toLowerCase(),
);

export type LDAPGroupSelectProps = {
  selectedGroups: LdapGroupSelectFragment[];
  onGroupSelected: (group: string) => void;
};
export const LDAPGroupSelect: FC<LDAPGroupSelectProps> = ({ selectedGroups, onGroupSelected }) => {
  const [selected, setSelected] = useState<string>();

  const handleSelectionAdditions = useCallback(
    (value: string) => {
      const currentSelectedGroups = Array.from(selectedGroups).map((selected) => selected.ldapGroup);

      if (!currentSelectedGroups.includes(value)) {
        onGroupSelected(value);
        setSelected(undefined);
      }
    },
    [
      onGroupSelected,
      selectedGroups,
    ],
  );

  return (
    <Select onChange={handleSelectionAdditions} placeholder="Add LDAP Groups" popoverMaxHeight={200} value={selected}>
      {LDAPGroupOptions.filter(
        (option) =>
          !Array.from(selectedGroups)
            .map((groupObj) => groupObj.ldapGroup)
            .includes(option.value),
      ).map((option) => (
        <SelectOption data-cy={`ldap-group-option-${option.value}`} key={option.value} label={option.text} value={option.value} />
      ))}
    </Select>
  );
};
